// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_1-Tabs_tabs_laoUM"};